import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';
import { DEFAULT_PAGE_SIZE } from '../config/config';
import rolesService from '../services/RolesService';
import { PaginationParams } from '../types';
import { transformToValueLabel } from '../utils/functions';
import { mapErrorMessage } from '../utils/mapErrorMensage';


class RolesStore {
    loading: boolean = false;
    rolesList: any[] = [];
    role: any | undefined;
    sort?: string = '';
    listRoles: any;
    totalPages: number = 0;
    page: number = 0;
    totalElements: number = 0;
    size: number = DEFAULT_PAGE_SIZE;
    defaultparams = {
        size: DEFAULT_PAGE_SIZE,
        page: 0,
        sort: 'created,desc',
        search: '',
    }

    constructor() {
        makeAutoObservable(this);
    }

    reset() {
        this.role = undefined;
        this.rolesList = [];
        this.listRoles = [];
    }

    async getList(params: PaginationParams) {
        this.loading = true;
        const response = await rolesService.getList(params);

        runInAction(() => {
            if (!response.error) {
                this.rolesList = response.data.content;
                this.totalPages = response.data.totalPages;
                this.page = response.data.number;
                this.totalElements = response.data.totalElements;
                this.size = response.data.size;
                this.sort = params.sort;
            }
            this.loading = false;
        });

        return response;
    }

    async createRoles(role: any) {
        this.loading = true;
        const response = await rolesService.createRoles(role);

        runInAction(() => {
            if (response.error) {
                message.error(`Erro ao criar Cargo`);
                this.role = role;
            } else {
                message.success('Cargo cadastrado com sucesso!');
            }

            this.loading = false;
        });
        return response;
    }


    async editRole(role: any, uuid: string | undefined) {
        this.loading = true;
        const response = await rolesService.editRoles(role, uuid);

        runInAction(() => {
            if (response.error) {
                message.error(mapErrorMessage(response?.details?.response?.data?.message));
                this.role = role;
            } else {
                message.success('Cargo editado com sucesso!');
            }
            this.loading = false;
        });

        return response;
    }

    async getRoleByUuid(uuid: string) {
        this.loading = true;
        const response = await rolesService.getRolesByUuid(uuid);

        runInAction(() => {
            if (response.error) {
                message.error(`Erro ao buscar Newsletter`);
                return;
            }
            this.listRoles = transformToValueLabel(response.data.authorityGroups, 'uuid', 'name');
            this.role = response.data;
            this.loading = false;
        });

        return response;
    }


    async deleteRoles(uuid: string) {
        this.loading = true;
        const response = await rolesService.deleteRoles(uuid);

        runInAction(() => {
            if (response.error) {
                message.error(`Erro ao deletar`);
            } else {
                message.success('Cargo deletado com sucesso!');
            }
            this.loading = false;
        });
        return response;
    }


    async deleteRolesAll(uuid: string) {
        this.loading = true;
        const response = await rolesService.deleteRoles(uuid);
        runInAction(() => {
            this.loading = false;
        });
        return response;
    }
}

const rolesStore = new RolesStore();
export default rolesStore;